import type ShariffLinkGeneratorInterface from "@/ts/components/Shariff/Interfaces/ShariffLinkGeneratorInterface";

export default class FacebookShareLinkGenerator implements ShariffLinkGeneratorInterface {
    public generateLink(url: string): string {
        return "https://www.facebook.com/sharer/sharer.php"
            + "?u=" + encodeURIComponent(url);
    }

}
